import { render, staticRenderFns } from "./RevenuePerCustomerType.vue?vue&type=template&id=1945f608&scoped=true"
import script from "./RevenuePerCustomerType.vue?vue&type=script&lang=js"
export * from "./RevenuePerCustomerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945f608",
  null
  
)

export default component.exports